export default __webpack_public_path__ + "static/media/signupImage3.615d1f38.webp";